
























































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { getSingleDate, maskDateTime, caraterCirurgiaMap, solicitacaoStatusSituacaoMap, getWeekdayByDate } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { Hospital } from '@/types/_'
import BackofficeMapaCirurgicoGradeStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoGradeStore'
import { useHospitais } from '@/composables'

@Component
export default class ViewBackofficeMapaCirugicoGrade extends Vue {
  $refs!: { finxCalendar: any }

  loadHospital: boolean = false
  get loadingHospital() { return this.loadHospital }
  set loadingHospital(value: boolean) { this.loadHospital = value }

  get hospital() { return this.getBackofficeMapaCirurgicoGradeStore.hospital }
  set hospital(value: Hospital) { this.getBackofficeMapaCirurgicoGradeStore.setHospital(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }


  get resources() {
    return this.getBackofficeMapaCirurgicoGradeStore.resources
  }

  get events() {
    return this.getBackofficeMapaCirurgicoGradeStore.filteredEvents
  }

  get calendarReady() {
    return !['', null, undefined].includes(this.hospital.id) && this.resources.length > 0
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeMapaCirurgicoGradeStore() {
    return getModule(BackofficeMapaCirurgicoGradeStore, this.$store)
  }

  get statusFiltered() {
    return {
      status: this.getBackofficeMapaCirurgicoGradeStore.filteredState,
      campo: this.getBackofficeMapaCirurgicoGradeStore.filteredField,
    }
  }

  get currentDate() {
    return this.getBackofficeMapaCirurgicoGradeStore.currentDate
  }

  get currentDateWeekday() {
    return this.currentDate ? getWeekdayByDate(this.currentDate) : ''
  }

  set currentDate(value: string) {
    this.getBackofficeMapaCirurgicoGradeStore.setCurrentDate(value)
  }

  isStatusFiltered(status: string = '') {
    if (!this.statusFiltered.status) return true
    return this.statusFiltered.status && ['', status].includes(this.statusFiltered.campo)
  }

  resetFilter() {
    this.getBackofficeMapaCirurgicoGradeStore.resetFilter()
  }

  filterEvents(campo: string, valor: string) {
    this.getBackofficeMapaCirurgicoGradeStore.filter({ campo, valor })
  }

  filterEventByLabelType(e: any) {
    this.getBackofficeMapaCirurgicoGradeStore.setEventByLabelType(e)
  }

  filterEventByView(e: any) {
    this.getBackofficeMapaCirurgicoGradeStore.setEventByView(e)
  }

  async filterEventByDate() {
    const { finxCalendar } = this.$refs
    finxCalendar.loadingCalendar = true
    await this.getBackofficeMapaCirurgicoGradeStore.getGradeMapaCirurgico()
    finxCalendar.loadingCalendar = false
    await finxCalendar.$refs.calendarComponent.getApi().gotoDate(this.getBackofficeMapaCirurgicoGradeStore.currentDate)
    await finxCalendar.$refs.calendarComponent.getApi().render()
  }

  get calendarExtraOptions() {
    const extraOptions: any = {
      timeZone: 'America/Sao_Paulo',
      contentHeight: this.windowHeight,
      aspectRatio: 1.35,
      initialView: 'resourceTimelineDay',
      resources: this.resources,
      resourceAreaHeaderContent: 'Salas',
      resourceAreaWidth: '250px',
      resourceOrder: 'centroCirurgicoNome, salaCirurgicaNome',
      events: this.events,
      eventOverlap: this.handleSurgeryScheduleOverlap,
    }
    if (this.getBackofficeMapaCirurgicoGradeStore.shouldGroupFields) extraOptions.resourceGroupField = 'centroCirurgicoNome'
    return extraOptions
  }

  get medicos() {
    return this.getBackofficeMapaCirurgicoGradeStore.medicos
  }

  get medicoSchedule() {
    return this.getBackofficeMapaCirurgicoGradeStore.medicoSchedule
  }

  handleItem() {
    //
  }

  handleSurgeryScheduleOverlap(stillEvent, movingEvent) {
    return true
  }

  maskDateTimeUtil(value: string) {
    return maskDateTime(value)
  }

  caraterCirurgiaMapUtil(value: string) {
    return caraterCirurgiaMap.get(value)
  }

  solicitacaoStatusSituacaoMapUtil(value: string) {
    return solicitacaoStatusSituacaoMap.get(value)
  }

  medicoScheduleTableHeaders: any[] = [
    { text: 'Paciente', class: 'table-headers-grey', align: 'left', value: 'pacienteNome' },
    { text: 'Médico', class: 'table-headers-grey', align: 'left', value: 'medicoNome' },
    { text: 'Caráter da cirurgia', class: 'table-headers-grey', align: 'center', value: 'carater' },
    { text: 'Sala cirúrgica', class: 'table-headers-grey', align: 'left', value: 'salaCirurgicaNome' },
    { text: 'Data e hora', class: 'table-headers-grey', align: 'center', value: 'horario' },
    { text: 'Status', class: 'table-headers-grey', align: 'left', value: 'solicitacaoStatusSituacao' },
  ]

  get medicoSolicitanteId() {
    return this.getBackofficeMapaCirurgicoGradeStore.medicoSolicitanteId
  }

  set medicoSolicitanteId(value: string) {
    this.getBackofficeMapaCirurgicoGradeStore.setMedicoSolicitanteId([null, undefined, ''].includes(value) ? '' : value)
  }

  loadMedicoSchedule: boolean = false
  get loadingMedicoSchedule() { return this.loadMedicoSchedule }
  set loadingMedicoSchedule(value: boolean) { this.loadMedicoSchedule = value }

  async getMedicoSchedule(e: any) {
    if (['', null, undefined].includes(e)) return
    this.loadingMedicoSchedule = true
    await this.getBackofficeMapaCirurgicoGradeStore.getPesquisaGradeMapaCirurgico()
    this.loadingMedicoSchedule = false
  }

  resetMedicoSchedule() {
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSchedule()
  }

  async hospitalChange(hospital: Hospital) {
    this.getBackofficeMapaCirurgicoGradeStore.setHospital(hospital)
    this.getBackofficeMapaCirurgicoGradeStore.setShouldGroupFields(false)
    this.getBackofficeMapaCirurgicoGradeStore.clearResources()
    this.getBackofficeMapaCirurgicoGradeStore.clearEvents()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicos()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSchedule()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSolicitanteId()
    this.getBackofficeMapaCirurgicoGradeStore.clearTemplate()
    this.loadingHospital = true

    this.getBackofficeMapaCirurgicoGradeStore.setCurrentDate(getSingleDate())
    await this.getBackofficeMapaCirurgicoGradeStore.getGradeMapaCirurgico()
    await this.getBackofficeMapaCirurgicoGradeStore.getAllMedicosByHospitalId()

    if (this.hospital.hospitalInformaMotivoDeTransferenciaReserva) {
      await this.getBackofficeMapaCirurgicoGradeStore.getMotivosTransferenciaReservaByHospital()
    }

    this.loadingHospital = false
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight - 60 - 24 - 67 - 42 - 24 - 78
      // this.windowHeight = doc.documentElement.clientHeight - 60 - 62
    }
  }

  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
    })

    EventBus.$on('calendarUpdateDatesSet', async (dateInfo: any) => {
      if (!this.getBackofficeMapaCirurgicoGradeStore.hospital.id || this.resources.length < 1) return
      if (this.getBackofficeMapaCirurgicoGradeStore.currentDate === dateInfo.startStr.substring(0, 10)) return

      this.getBackofficeMapaCirurgicoGradeStore.setCurrentDate(dateInfo ? dateInfo.startStr.substring(0, 10) : getSingleDate())
      const { finxCalendar } = this.$refs
      finxCalendar.loadingCalendar = true

      await this.getBackofficeMapaCirurgicoGradeStore.getGradeMapaCirurgico()
      finxCalendar.loadingCalendar = false
    })

    EventBus.$on('updateItensMapaCirurgicoGrade', async (response: boolean) => {
      if (response) {
        const { finxCalendar } = this.$refs
        finxCalendar.loadingCalendar = true

        await this.getBackofficeMapaCirurgicoGradeStore.getGradeMapaCirurgico()
        finxCalendar.loadingCalendar = false
      }
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
    })
  }

  beforeDestroy() {
    this.getBackofficeMapaCirurgicoGradeStore.setShouldGroupFields(false)
    this.getBackofficeMapaCirurgicoGradeStore.clearResources()
    this.getBackofficeMapaCirurgicoGradeStore.clearEvents()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicos()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSchedule()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSolicitanteId()
    this.getBackofficeMapaCirurgicoGradeStore.resetFilter()
    this.getBackofficeMapaCirurgicoGradeStore.clearMotivosTransferenciaReserva()
    this.getBackofficeMapaCirurgicoGradeStore.clearHospital()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  campoHabilitado(template: any, prop: string) {
    const { formulario } = template

    if (formulario && formulario[prop]) {
      const response = formulario[prop]

      // eslint-disable-next-line
      if (response) return response['habilitado']
    }

    return false
  }

  campoHabilitadoInAnyTemplate(prop: string) {
    const template = this.getBackofficeMapaCirurgicoGradeStore.template!

    const templates = [template]
    const templatePorConvenios = template.porConvenios || []
    templatePorConvenios.forEach((elem: any) => {
      templates.push(elem.template)
    })

    // eslint-disable-next-line no-restricted-syntax
    for (const elem of templates) {
      if (this.campoHabilitado(elem, prop)) {
        return true
      }
    }

    return false
  }

  get canShowFilterByView() {
    return this.campoHabilitadoInAnyTemplate('complexidade')
  }
}
